module.exports = __webpack_public_path__ + "static/media/notes.abc40249.svg";